import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { silentLogin } from "store/bailiff/login/login.action";
import { isLoggedSelector as isLoggedSelectorUser } from "store/user/auth/user_auth.selector";
import { isLoggedSelector as isLoggedSelectorBase } from "store/bailiff/auth/bailiff_auth.selector";
import { permissionsSelector as permissionUser } from "store/user/auth/user_auth.selector";
import { permissionsSelector as permissionBase } from "store/bailiff/auth/bailiff_auth.selector";

//
//component
//redux
//selector
//actions
const TriggerRelogin = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const loggedA = useSelector(isLoggedSelectorUser);
  const loggedB = useSelector(isLoggedSelectorBase);
  const perA = useSelector(permissionUser);
  const perB = useSelector(permissionBase);

  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    const time = `time ${moment()?.toISOString()}`;
    if (loggedA === true && loggedB === true && perA !== perB) {
      dispatch(silentLogin());
      console.log("trigger relogin" + " " + time);
    }
  }, [loggedA, loggedB, perA, perB, dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerRelogin;
